import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
  // Avatar,
  // Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  IconButton, 
  LinearProgress,
} from '@material-ui/core';

//import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

// import EditIcon from '@material-ui/icons/Edit';
// import VisibilityIcon from '@material-ui/icons/Visibility';

//import { getInitials } from 'helpers';


import { timeToKorTime } from 'common/utils';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  rowIcons: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    //paddingLeft: theme.spacing(8),
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const StatisticsTable = props => {
  const { 
    className, 
    type,
    find_type,
    statistics,
    advertiseLogs,
    taxiLogs,
    clientLogs,

    onClickOpenDownloadDialog,
    
    openProgress,
    page,
    rowsPerPage,
    item_total,
    onPageChange,
    onRowsPerPageChange,

    ...rest 
  } = props;

  const classes = useStyles();

  //const [selectedStatistics, setSelectedStatistics] = useState([]);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [page, setPage] = useState(0);

  // const handlePageChange = (event, page) => {
  //   //console.log(page);
  //   setPage(page);
  // };

  // const handleRowsPerPageChange = event => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(0);
  // };

  // useEffect(() => {
  //   console.log('componentDidUpdate & type changed');

  // }, [type]);

  // useEffect(() => {
  //   //console.log('componentDidUpdate & statistics changed');

  // }, [statistics]);

  return (
    <div>

      <div className={classes.rowIcons}>
        <IconButton
          onClick={onClickOpenDownloadDialog}
        >
            <CloudDownloadIcon />
        </IconButton>
      </div>
      
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.content}>
        <PerfectScrollbar>
        {type === 'advertise' && (
            <div className={classes.inner}>
              {openProgress && <LinearProgress /> }
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>광고명</TableCell>
                    <TableCell>템플릿</TableCell>
                    <TableCell>광고유형</TableCell>
                    <TableCell>광고대행사</TableCell>
                    <TableCell>광고주</TableCell>
                    <TableCell>권역</TableCell>
                    <TableCell>그룹</TableCell>
                    <TableCell>택시회사명</TableCell>
                    <TableCell>차량번호</TableCell>
                    <TableCell>{(find_type === 0 || find_type === 1) ? '재생횟수' : '재생일시'}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {advertiseLogs.map((statistic, index) => (
                    <TableRow
                      className={classes.tableRow}
                      hover
                      key={index}
                      //selected={selectedStatistics.indexOf(statistic.id) !== -1}
                    >
                      <TableCell>
                        <div className={classes.nameContainer}>
                          <Typography variant="body1">{statistic.name}</Typography>
                        </div>
                      </TableCell>
                      <TableCell>{statistic.template}</TableCell>
                      <TableCell>{statistic.type === 'normal' ? '유료' : '무료'}</TableCell>
                      <TableCell>{statistic.agency}</TableCell>
                      <TableCell>{statistic.client}</TableCell>
                      <TableCell>{statistic.area}</TableCell>
                      <TableCell>{statistic.group}</TableCell>
                      <TableCell>{statistic.company}</TableCell>
                      <TableCell>{statistic.car_number}</TableCell>
                      {(find_type === 0 || find_type === 1) ? 
                        (<TableCell align='right'>{statistic.log_count && statistic.log_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+'회'}</TableCell>) :
                        (<TableCell>{statistic.log_at && moment(statistic.log_at).format('YYYY-MM-DD HH:mm:ss')}</TableCell>)
                      }
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
            )
          }
          {type === 'taxi' && (
              <div className={classes.inner}>
                {openProgress && <LinearProgress /> }
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>택시회사명</TableCell>
                      <TableCell>차량번호</TableCell>
                      <TableCell>승/하차</TableCell>
                      <TableCell>{(find_type === 1) ? '횟수' : '생성일시'}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {taxiLogs.map((statistic, index) => (
                      <TableRow
                        className={classes.tableRow}
                        hover
                        key={statistic.id}
                        //selected={selectedStatistics.indexOf(statistic.id) !== -1}
                      >
                        <TableCell>
                          <div className={classes.nameContainer}>
                            <Typography variant="body1">{statistic.company != null ? statistic.company : '미등록' }</Typography>
                          </div>
                        </TableCell>
                        <TableCell>{statistic.car_number != null ? statistic.car_number : '미등록'}</TableCell>
                        <TableCell>
                          {
                            statistic.event === 'get_on' ? '승차' : 
                            statistic.event === 'get_off' ? '하차' :
                            statistic.event
                          }
                        </TableCell>
                        {(find_type === 1) ? 
                          (<TableCell align='right'>{statistic.log_count && statistic.log_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+'회'}</TableCell>) :
                          (<TableCell>{statistic.log_at && moment(statistic.log_at).format('YYYY-MM-DD HH:mm:ss')}</TableCell>)
                        }
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            )
          }
          { type === 'client' &&
            (
              <div className={classes.inner}>
                {openProgress && <LinearProgress /> }
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>광고대행사명</TableCell>
                      <TableCell>광고주명</TableCell>
                      <TableCell>광고명</TableCell>
                      <TableCell>템플릿</TableCell>
                      <TableCell>광고유형</TableCell>
                      <TableCell>광고기간</TableCell>
                      <TableCell>전체뷰카운트</TableCell>
                      <TableCell>계약금액</TableCell>
                      <TableCell>등록자</TableCell>
                      <TableCell>등록일</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {clientLogs.map((client_log, index) => (
                      <TableRow
                        className={classes.tableRow}
                        hover
                        key={client_log.id}
                        //selected={selectedStatistics.indexOf(statistic.id) !== -1}
                      >
                        <TableCell>
                          <div className={classes.nameContainer}>
                            <Typography variant="body1">{client_log.agency}</Typography>
                          </div>
                        </TableCell>
                        <TableCell>{client_log.client}</TableCell>
                        <TableCell>{client_log.name}</TableCell>
                        <TableCell>{client_log.template}</TableCell>
                        <TableCell>{client_log.type === 'normal' ? '유료' : '무료'}</TableCell>
                        <TableCell>
                          {client_log.start_date ? moment(client_log.start_date).format('YYYY-MM-DD') : ''}
                          ~
                          {client_log.end_date ? moment(client_log.end_date).format('YYYY-MM-DD') : ''}</TableCell>
                        {/* <TableCell>{client_log.view_count}</TableCell> */}
                        {/* <TableCell>{client_log.cost}</TableCell> */}
                        <TableCell align='right'>{client_log.view_count && client_log.view_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+'회'}</TableCell>
                        <TableCell align='right'>{client_log.cost && client_log.cost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+'원'}</TableCell>
                        <TableCell>{client_log.modified_user}</TableCell>
                        <TableCell>{client_log.modified_at ? moment(client_log.modified_at).format('YYYY-MM-DD') : ''}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            )
          }
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={classes.actions}>
        <TablePagination
          labelRowsPerPage=''
          component="div"
          count={item_total}
          onChangePage={onPageChange}
          onChangeRowsPerPage={onRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </CardActions>
    </Card>

    </div>
  );
};

StatisticsTable.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  statistics: PropTypes.array.isRequired,
  //onSetSelectedStatistics: PropTypes.func,
};

StatisticsTable.defaultProps = {
  statistics: [],
};

export default StatisticsTable;
